import './Error.css';

function Error() {
   return (
      <div className="error">
         <h1 className="error__title">Oops!</h1>
         <p className="error__text">Il y a eu un petit problème...</p>
      </div>
   );
}

export default Error;
